module.exports = __webpack_public_path__ + "baaa923598c6d09bdbed4911e02d62ac.svg";